import React from 'react'
import { PageTitle } from '../components/general/page-title'
import { dayjs } from '../lib/dayjs'
import * as Styles from './post.module.scss'
import { Layout } from '@/components/general/layout'
import { Seo } from '@/components/general/seo'
import { withPrefix } from 'gatsby'

export default function Post({ pageContext, location }) {
  const { node } = pageContext
  return (
    <Layout location={location}>
      <Seo
        title={node.title}
        description={`Uniforceのお知らせ「${node.title}」についてです。決算開示業務を「最短・最適ルート」へと導くというコンセプトのもと、業務全体を見渡しながら正しい順序でナビゲーションし、細かなタスクの抜け漏れを防ぎ、スムーズで快適な業務を遂行することができる業界初のDXソリューションサービスです。`}
      />
      <article className={Styles.post}>
        <header>
          <PageTitle decorationLogo>
            <div className={Styles.post__img}>
              <Image
                src={node.coverImage ? node.coverImage.url : ''}
                alt={node.title}
              />
            </div>
          </PageTitle>
        </header>
        <div className={Styles.post__textbox}>
          <date className={Styles.post__date}>
            {dayjs(node.publishedAt).format('YYYY/MM/DD')}
          </date>
          <h1>{node.title}</h1>
          <p className={Styles.post__category}>{node.category.title}</p>
          <div
            dangerouslySetInnerHTML={{
              __html: node.body,
            }}
          ></div>
        </div>
      </article>
    </Layout>
  )
}

const Image = ({ src, alt = '' }) => {
  return src ? (
    <img src={`${src}?fm=webp&w=574`} width={574} alt={alt} />
  ) : (
    <img src={withPrefix('/ogp.png')} width={574} height={300} alt={alt} />
  )
}
